'use strict';

angular.module('adminDefaultEntitlementControllers')

.controller('ViewExistingRightsController', ['$scope', '$state', '$stateParams', '$controller', 'businessSystemService', 'adminDefaultEntitlementService', function ($scope, $state, $stateParams, $controller, businessSystemService, adminDefaultEntitlementService) {

    $scope.entitlements = [];

    $controller('BaseFeatureController', {
                $scope: $scope, $state: $state, $stateParams: $stateParams, businessSystemService: businessSystemService
    });

    adminDefaultEntitlementService.getDefaultEntitlementsBySystemRoleId($scope.systemRoleId)
                                  .then(function (entitlements) {
                                          $scope.entitlements = entitlements;
                                  });
}]);
